import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { listWorkstreams } from './client';
import { keys } from './keys';

/**
 * Fetch the caller's workstreams (S-C1) — the SPA's single source of
 * workstream data, used by the rail (C2/C3). Keyed by `keys.workstream.listMine()`
 * so the create mutation can invalidate it on success and the new bubble
 * appears without a reload.
 *
 * Loading + error states are surfaced to the caller via React Query's standard
 * fields; errors are also routed to `reportError` through the shared
 * `QueryCache.onError` (queryClient.ts).
 */
export function useWorkstreams() {
  const { getAccessToken } = useAuth();
  return useQuery({
    queryKey: keys.workstream.listMine(),
    queryFn: ({ signal }) => listWorkstreams({ getAccessToken, signal }),
  });
}
